<template>
  <div>
    <AccountLink
      :sign-in-notification-experience="signInNotificationExperience"
      :rewards-balance="`${zeroRewardsNavExperience === 'variant1' ? '$0.00' : ''}`"
    />
    <AccountLink
      link-text="My Account - Sign in or Register"
      is-mobile-only
      mounting-point-selector="[data-js='mobile-nav-login-link']"
      :gugo-experience="gugoExperience"
    />
  </div>
</template>

<script>
import { AccountLink } from '@rei/account-flyout';

export default {
  name: 'AccountLinkFragment',
  components: {
    AccountLink,
  },
  props: {
    signInNotificationExperience: {
      type: String,
      default: 'control',
    },
    zeroRewardsNavExperience: {
      type: String,
      default: 'control',
    },
    gugoExperience: {
      type: String,
      default: 'control',
    },
  },
};
</script>
